<template>
  <div class="login">
    <div class="card-header"></div>
    <div class="card">
      <h1 class="title">餐饮系统登录</h1>
      <div class="input">
        <a-input type="text" placeholder="用户名" @keyup.enter="submit" v-model:value.trim="formState.username"></a-input>
      </div>
      <div class="input">
        <a-input-password v-model:value.trim="formState.password" placeholder="密码" @keyup.enter="submit" />
      </div>
      <div class="btn">
        <a-button @click="submit" :loading="formState.isloading">登录</a-button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { login } from '@src/scripts/api/store'
import { getBasicData } from '@src/scripts/system'
import util from '@src/scripts/util'
import { nextTick } from 'vue'
import { reactive } from 'vue'

const formState = reactive({
  username: '',
  password: '',
  isloading: false
})

const submit = async () => {
  if (!formState.username || !formState.password) return
  formState.isloading = true
  setTimeout(() => formState.isloading = false, 2000)
  const data = await login(formState.username, util.encrypt(formState.password) as string)
  formState.isloading = false
  if (data.data) {
    $util.message.error({
      duration: 3,
      content: data.data
    })
    return
  }

  await getBasicData()
  $router.push('/')
}

</script>